import React, { useEffect, useState } from "react"
import styled from "styled-components"

import Link from "@airasia/phoenix-components/components/Link"
import Text from "@airasia/phoenix-components/components/Text"

const TextWrapper = styled.div`
  border-style: solid;
  padding: 0px 8px 8px 8px;
  border-width: thin;
  border-color: gray;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 1px;
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(213, 217, 226);
`

const StyledText = styled.div`
  margin-bottom: 15px;
`

StyledText.displayName = "StyledText"

const LinkContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: 0px 8px;
`

LinkContainer.displayName = "LinkContainer"

const LinkDiv = styled.div`
  width: 25%;
  margin: 10px 0px;
  @media screen and (max-width: 768px) {
    width: 50%;
  }
`

LinkDiv.displayName = "LinkDiv"

const ExpandToggleDiv = styled.div`
  display: ${props => (props.show ? "none" : "inline")};
`

const ExpandedLinkContainer = styled.div`
  display: ${props => (props.show ? "inline" : "none")};
`

// gets the nth occurence of the substring
String.prototype.nth_Index_Of = function (pattern, n) {
  var i = -1

  while (n-- && i++ < this.length) {
    i = this.indexOf(pattern, i)
    if (i < 0) break
  }

  return i
}

const ExpandableContentBlock = props => {
  const { contentBlock, translations } = props

  const [showMoreToggle, setShowMoreToggle] = useState(false)

  // Cuts the block at second <p> element
  const secondParagraphIndex = contentBlock.nth_Index_Of("<h", 2)
  const firstBlock =
    secondParagraphIndex !== -1
      ? contentBlock.slice(0, secondParagraphIndex)
      : contentBlock

  const secondBlock = contentBlock.slice(secondParagraphIndex)

  return (
    <TextWrapper>
      <Text display="inline">
        <div
          dangerouslySetInnerHTML={{
            __html: firstBlock,
          }}
        />
        {secondParagraphIndex !== -1 && (
          <>
            <ExpandToggleDiv show={showMoreToggle}>
              <Link
                target="callback"
                callback={() => setShowMoreToggle(true)}
                color="secondary"
              >
                {translations.blockExpandText} ↓
              </Link>
            </ExpandToggleDiv>
            <ExpandedLinkContainer show={showMoreToggle}>
              <div
                dangerouslySetInnerHTML={{
                  __html: secondBlock,
                }}
              />
              <LinkDiv>
                <Link
                  target="callback"
                  callback={() => setShowMoreToggle(false)}
                  color="secondary"
                >
                  {translations.blockCompressText} ↑
                </Link>
              </LinkDiv>
            </ExpandedLinkContainer>
          </>
        )}
      </Text>
    </TextWrapper>
  )
}

export default ExpandableContentBlock
